import React, { useState, useEffect } from "react";
import axiosConfig from "../Service/axiosConfig"
import { FormParser } from "../Components";
import { useParams } from "react-router-dom";
import { Row, Modal } from 'react-bootstrap';
import Masters from "../Components/masters.json"
import { Requirementcontsnt } from "./Requirementcontsnt";
import context from "react-bootstrap/esm/AccordionContext";

const AuditionRequirements = () => {
    let { id } = useParams();
    const [requirementShow, setRequirementShow] = useState(false)
    const [requirementData, setRequirementData] = useState([])
    const [Data, setData] = useState({})
    const GetRequirementdata = async () => {
        try {
            const responce = await axiosConfig.get(`/accounts/audition-requirements/?audition=${id}`)
            console.log(responce)
            setRequirementData(responce.data.results);
        }
        catch (error) {
            console.log(error)
        }
    }
   const AudiRequirements = async (formData, setFieldErrors) => {
    let OrderToPost = {
        ...formData,
        audition: id,
    };

    if (
        formData?.from_age && formData?.to_age &&
        Number(formData.from_age) >= Number(formData.to_age)
    ) {
        const errorMessage = "From age must be less than To age.";
        setFieldErrors(prev => ({
            ...prev,
            from_age: errorMessage,
            to_age: errorMessage
        }));
        return;
    }

    const formDataToSend = new FormData();

    if (OrderToPost.role) formDataToSend.append("role", OrderToPost.role);
    if (OrderToPost.character) formDataToSend.append("character", OrderToPost.character);
    if (OrderToPost.no_of_requirements) formDataToSend.append("no_of_requirements", OrderToPost.no_of_requirements);
    if (OrderToPost.gender) formDataToSend.append("gender", OrderToPost.gender);
    if (OrderToPost.from_age) formDataToSend.append("from_age", OrderToPost.from_age);
    if (OrderToPost.to_age) formDataToSend.append("to_age", OrderToPost.to_age);
    if (OrderToPost.budget) formDataToSend.append("budget", OrderToPost.budget);

    if (OrderToPost.state && Array.isArray(OrderToPost.state)) {
        OrderToPost.state.forEach(s => formDataToSend.append("state", s));
    } else if (OrderToPost.state) {
        formDataToSend.append("state", OrderToPost.state);
    }

    if (OrderToPost.city && Array.isArray(OrderToPost.city)) {
        OrderToPost.city.forEach(c => formDataToSend.append("city", c));
    } else if (OrderToPost.city) {
        formDataToSend.append("city", OrderToPost.city);
    }

    if (OrderToPost.languages && Array.isArray(OrderToPost.languages)) {
        OrderToPost.languages.forEach(l => formDataToSend.append("languages", l));
    } else if (OrderToPost.languages) {
        formDataToSend.append("languages", OrderToPost.languages);
    }

    if (OrderToPost.specification) formDataToSend.append("specification", OrderToPost.specification);
    if (OrderToPost.audition) formDataToSend.append("audition", OrderToPost.audition);
    if (OrderToPost.approval_status) formDataToSend.append("approval_status", OrderToPost.approval_status);
    if (OrderToPost.thumbnail && typeof OrderToPost.thumbnail !== "string") {
        formDataToSend.append("thumbnail", OrderToPost.thumbnail);
    }

    try {
        const res = await axiosConfig.post(
            "/accounts/audition-requirements/",
            formDataToSend,
            { headers: { "Content-Type": "multipart/form-data" } }
        );
        console.log(res);
        GetRequirementdata();
        setRequirementShow(false);
    } catch (error) {
        console.log(error.response?.data || error.message);
    }
};

    useEffect(() => {
        GetRequirementdata()
    }, [])
    return (
        <>
            <div className="row">
                <div className="col-9">
                    <h6>Requirements</h6>
                </div>
                <div className="col-3">
                    {/* <button type="button" className="btn btn-success apply-new-craft" onClick={() => setshowApply(true)} >Apply New Craft</button> */}
                    <button className="btn btn-success apply-new-craft" onClick={() => {
                        setData({})
                        setRequirementShow(true)
                    }}>+Add Requirements</button>
                </div>
            </div>
            <div className="investment-screen">
                <div className="row">
                    {requirementData.map((requirement, index) => (
                        <Requirementcontsnt Data={requirement} GetData={GetRequirementdata} />
                    ))}
                </div>
            </div>
            <Modal
                size="lg"
                show={requirementShow}
                onHide={() => {
                    setData({})
                    setRequirementShow(false)
                }}
                aria-labelledby="example-modal-sizes-title-lg"
            >
                <Modal.Header closeButton>
                    <Modal.Title id="example-modal-sizes-title-lg">
                        Add Audition Requirements
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <FormParser modelObject={Masters.AditionRequirements} formData={Data} formSubmit={AudiRequirements} error={Error} />
                </Modal.Body>
            </Modal>
        </>
    )
}
export { AuditionRequirements };